// extracted by mini-css-extract-plugin
export default {"reflection_content_wrapper":"AnaNlFlargoDgpwH2ZnQ","scrollableArea":"Rdxlije9alHzI7aY0tQL","expandText__reflection":"gQB9bKhCK6G7ir6ZNQ7B"};